// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single-abstract-title-5cf10{padding-bottom:.45rem}.single-abstract-cardWrap-84f88:first-child{margin-top:.45rem}.single-abstract-line-0f989{background-color:#e0e0e0;height:.0033rem;margin:.31rem 0 .45rem}.single-abstract-moreTextWrap-8a798{align-items:center;display:flex;justify-content:center}.single-abstract-moreText-27dc3{color:#1f1f1f;font-family:PingFangSC-Regular;font-size:.42rem;line-height:.42rem}.single-abstract-arrow-bae18{display:block;height:.42rem;margin-left:.06rem;width:.42rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "single-abstract-title-5cf10",
	"cardWrap": "single-abstract-cardWrap-84f88",
	"line": "single-abstract-line-0f989",
	"moreTextWrap": "single-abstract-moreTextWrap-8a798",
	"moreText": "single-abstract-moreText-27dc3",
	"arrow": "single-abstract-arrow-bae18"
};
export default ___CSS_LOADER_EXPORT___;
